export const ARTICLES_BASE_URL = '/articles';